import React from 'react';
import { Link } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import './Dashboard.css';

export default function Dashboard() {
  const { user } = useAuth();

  return (
    <div className="dashboard">
      <h1>Willkommen, {user?.username}!</h1>
      <h2>Material-Verwaltungssystem</h2>
      <p className="subtitle">
        BRK Dachau - Bereitschaft Markt Indersdorf        
      </p>

      <div className="dashboard-cards">
        <Link to="/inventory" className="dashboard-card">
          <h2>Inventar</h2>
          <p>Fahrzeuge, Rucksäcke und Versorgungseinheiten verwalten</p>
        </Link>

        <Link to="/orders" className="dashboard-card">
          <h2>Bestellungen</h2>
          <p>Fehlende Items bestellen und Bestellungen verwalten</p>
        </Link>

        <Link to="/expiry-calendar" className="dashboard-card">
          <h2>Verfallskalendar</h2>
          <p>Alle Ablaufdaten auf einen Blick prüfen</p>
        </Link>

        <div className="dashboard-card info">
          <h2>Info</h2>
          <p>Version 2.0</p>
          <p className="note">Bestellsystem, Online Material Verwaltung, Verfallsdatumskalender</p>
        </div>
      </div>
    </div>
  );
}
